/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SendVerificationCodeRequest } from '../models/SendVerificationCodeRequest';
import type { UpdateUserLeadRoleRequest } from '../models/UpdateUserLeadRoleRequest';
import type { User } from '../models/User';
import type { VerifyEmailCodeRequest } from '../models/VerifyEmailCodeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * @param userUId
     * @returns User OK
     * @throws ApiError
     */
    public static getApiUser(
        userUId: number,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/{userUId}',
            path: {
                'userUId': userUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns User OK
     * @throws ApiError
     */
    public static postApiUser(
        requestBody?: User,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiUserSendVerificationCode(
        requestBody?: SendVerificationCodeRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User/send-verification-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiUserVerifyEmailCode(
        requestBody?: VerifyEmailCodeRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User/verify-email-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param email
     * @param displayName
     * @param userName
     * @param id
     * @param teamCode
     * @returns User OK
     * @throws ApiError
     */
    public static getApiUserSearch(
        email?: string,
        displayName?: string,
        userName?: string,
        id?: number,
        teamCode?: string,
    ): CancelablePromise<Array<User>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/User/search',
            query: {
                'email': email,
                'displayName': displayName,
                'userName': userName,
                'id': id,
                'teamCode': teamCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns User OK
     * @throws ApiError
     */
    public static postApiUserLeadRole(
        requestBody?: UpdateUserLeadRoleRequest,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/User/lead-role',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
